import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ZodError } from "zod";

export function handleApiError(error: unknown): string {
	if (error instanceof ZodError) {
		const errorMessage = error.issues
			.map((err) => `${err.path.join(".")}: ${err.message}`)
			.join("; ");
		toast.error(`Validation Error: ${errorMessage}`);
		return errorMessage;
	}

	if (error instanceof AxiosError) {
		let message: string;

		if (error.response?.data && error.response.data instanceof ArrayBuffer) {
			try {
				const decoder = new TextDecoder("utf-8");
				const text = decoder.decode(error.response.data);

				let parsed: { detail?: string } | undefined;
				try {
					parsed = JSON.parse(text);
					message = parsed?.detail || text;
				} catch {
					message = text;
				}
			} catch {
				message = "Unknown error occurred (failed to decode error response)";
			}
		} else {
			message = error.response?.data?.detail || error.message;
		}

		toast.error(`API Error: ${message}`);
		return message;
	}

	const message =
		error instanceof Error ? error.message : "Unknown error occurred";
	toast.error(message);
	return message;
}
